"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _AbsoluteLink = _interopRequireDefault(require("./AbsoluteLink"));
var _templateObject, _templateObject2;
var Message = _styledComponents["default"].small(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: block;\n  margin: 1em auto;\n  max-width: 500px;\n"])));
var Disclaimer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  max-width: 650px;\n  margin: 0 auto;\n  border: 1px solid #e3e3e3;\n  border-radius: 5px;\n  background-color: #eff5f9;\n  padding: 1em;\n  font-size: 0.7em;\n  color: black;\n  line-height: 180%;\n"])));
var contactUs = _react["default"].createElement(_AbsoluteLink["default"], {
  to: "/contact",
  target: "_blank"
}, _react["default"].createElement(_reactIntl.FormattedMessage, {
  id: "htmPayment.general.contactUs"
}));
var termsAndConditions = _react["default"].createElement(_AbsoluteLink["default"], {
  to: "/terms-and-conditions",
  target: "_blank"
}, _react["default"].createElement(_reactIntl.FormattedMessage, {
  id: "htmPayment.general.terms"
}));
var Footer = function Footer(_ref) {
  var provider = _ref.provider;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(Message, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.messages.fineprint",
    values: {
      contactUs: contactUs,
      termsAndConditions: termsAndConditions
    }
  })), _react["default"].createElement(Disclaimer, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.".concat(provider, ".service.disclaimer")
  })));
};
var _default = exports["default"] = Footer;